import Axios from 'axios';
import { axiosTemplate } from '../../axiosTemplate';
export const authproviderwrapper = {
    endpoints: {
        test: `https://q23refws0c.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: 'https://j6b5uyi7kc.execute-api.us-east-1.amazonaws.com/acceptance',
        prod: 'https://w4pozfrfbb.execute-api.us-east-1.amazonaws.com/prod',
    },
    http: {
        getClients: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${authproviderwrapper.endpoints[stage]}/client`);
        },
        getMetjwt: ({ stage, metjwt, clientId, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${authproviderwrapper.endpoints[stage]}/getMetjwt/${clientId}`);
        },
        getUserPermissions: ({ metjwt, stage, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${authproviderwrapper.endpoints[stage]}/getUserPermissions`);
        },
        oktalogin: ({ accessToken, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/oktalogin`, {
                accessToken,
            });
        },
        usermigration: ({ email, password, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/usermigration`, {
                email,
                password,
            });
        },
        graphQL: ({ data, stage, metjwt, cancelToken }) => {
            console.warn('This endpoint is deprecated, please use auth instead of authproviderwrapper');
            return axiosTemplate(metjwt, cancelToken).post(`${authproviderwrapper.endpoints[stage]}/x/graphql`, data);
        },
        addUserToRole: ({ data, stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).post(`${authproviderwrapper.endpoints[stage]}/x/add-user-to-role`, data);
        },
        firebasemessagetoken: ({ metjwt, stage, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${authproviderwrapper.endpoints[stage]}/firebasemessagetoken`);
        },
        cognitologin: ({ accessToken, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/cognitologin`, { accessToken });
        },
        checkIsMSLAdmin: ({ stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).get(`${authproviderwrapper.endpoints[stage]}/x/is-msl-admin`);
        },
        superAdminGraphql: ({ data, stage, metjwt, cancelToken }) => {
            return axiosTemplate(metjwt, cancelToken).post(`${authproviderwrapper.endpoints[stage]}/x/super-admin/graphql`, data);
        },
        oktaAddUserToGroup: ({ email, password, oktaUserId, stage }) => {
            const data = { email, password, oktaUserId };
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/add-user-to-group`, data);
        },
        addUserToOktaMovGroup: ({ email, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/add-user-to-okta-mov-group`, { email });
        },
        oktaSignup: ({ data, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/signup`, data);
        },
        oktaChangePassword: ({ email, oldPassword, newPassword, stage, metjwt }) => {
            return axiosTemplate(metjwt).post(`${authproviderwrapper.endpoints[stage]}/okta/change-password`, { email, newPassword, oldPassword });
        },
        oktaResetPassword: ({ newPassword, stateToken, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/reset-password`, { stateToken, newPassword });
        },
        oktaForgotPasswordRecoveryToken: ({ email, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/forgot-password-recovery-token`, { email });
        },
        oktaInviteUserToRole: ({ data, stage, metjwt }) => {
            return axiosTemplate(metjwt).post(`${authproviderwrapper.endpoints[stage]}/okta/invite-user-to-role`, data);
        },
        oktaChangeTemporaryPassword: ({ email, oldPassword, newPassword, stage }) => {
            return Axios.post(`${authproviderwrapper.endpoints[stage]}/okta/change-temporary-password`, { email, oldPassword, newPassword });
        },
    },
};
